/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; activating and reloading.')
      // The new worker is installed with skipWaiting; once it takes control,
      // reload once so the page runs the new bundle (guards against a loop).
      const reloadOnce = () => {
        if (sessionStorage.getItem('sw_reloaded') === '1') return
        sessionStorage.setItem('sw_reloaded', '1'); setTimeout(() => sessionStorage.removeItem('sw_reloaded'), 10000)
        window.location.reload()
      }
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
      navigator.serviceWorker.addEventListener('controllerchange', reloadOnce, { once: true })
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
